import React, { useEffect, useState } from 'react';

const typeConfig = {
  success: { bg: '#E1F5EE', color: '#0F6E56', border: '#A8DEC9' },
  error:   { bg: '#FAECE7', color: '#993C1D', border: '#F0B9A8' },
  info:    { bg: '#FFF8EC', color: '#8B6914', border: '#F0D99A' },
};

function ToastItem({ id, message, type, onRemove }) {
  const [visible, setVisible] = useState(false);
  const cfg = typeConfig[type] || typeConfig.info;

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
    const t = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onRemove(id), 300);
    }, 3000);
    return () => clearTimeout(t);
  }, [id, onRemove]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '10px',
      backgroundColor: cfg.bg,
      color: cfg.color,
      border: `1px solid ${cfg.border}`,
      borderRadius: '8px',
      padding: '12px 14px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.10)',
      minWidth: '260px',
      maxWidth: '360px',
      transform: visible ? 'translateX(0)' : 'translateX(110%)',
      opacity: visible ? 1 : 0,
      transition: 'transform 0.3s ease, opacity 0.3s ease',
      pointerEvents: 'all',
    }}>
      <span style={{ flex: 1, fontSize: '13px', fontWeight: '500', lineHeight: '1.4', fontFamily: 'Inter, sans-serif' }}>
        {message}
      </span>
      <button
        onClick={() => { setVisible(false); setTimeout(() => onRemove(id), 300); }}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: cfg.color,
          fontSize: '16px',
          lineHeight: '1',
          padding: '0',
          opacity: 0.7,
          flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}

export default function Toast({ toasts, onRemove }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        zIndex: 9999,
        pointerEvents: 'none',
      }}>
      {toasts.map(t => (
        <ToastItem key={t.id} id={t.id} message={t.message} type={t.type} onRemove={onRemove} />
      ))}
    </div>
  );
}
